'use client'

import { useTexts } from '@/contexts/LanguageContext'
import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import PoweredBy from './PoweredBy'

export default function Footer() {
  const { PUBLIC_TRUST_CENTER } = useTexts()
  const { organizationName } = useTrustCenterConfig()
  return (
    <footer className="border-t border-trust-center-border bg-trust-center-subtle">
      <div className="mx-auto flex w-full max-w-screen-2xl items-center gap-3 px-4 py-6 text-xs text-trust-center-muted md:px-12">
        {organizationName && (
          <span>{PUBLIC_TRUST_CENTER.FOOTER.COPYRIGHT(new Date().getFullYear(), organizationName)}</span>
        )}
        <span className="flex-1" />
        <PoweredBy className="flex" logoClassName="bg-trust-center-muted" />
      </div>
    </footer>
  )
}
